var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenFilledBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4246 4.57549C18.4483 3.5992 16.8655 3.59918 15.8891 4.57546L14.8285 5.63614L18.364 9.17164L19.4246 8.11103C20.4009 7.13472 20.4009 5.55181 19.4246 4.57549Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1213 6.34324L17.6569 9.87875L8.81805 18.7176C8.74825 18.7874 8.65935 18.8349 8.56255 18.8543L5.02702 19.5614C4.86309 19.5942 4.69362 19.5429 4.57541 19.4247C4.4572 19.3064 4.40589 19.137 4.43867 18.9731L5.14578 15.4375C5.16514 15.3407 5.21272 15.2518 5.28252 15.182L14.1213 6.34324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenFilledBlack);
export default __webpack_public_path__ + "static/media/pen-filled-black.5ed1478c495ead189e1b4621bda037f8.svg";
export { ForwardRef as ReactComponent };